import { PageResponse } from "../../applications/constants/AppTypes";
import { buildRequestToParams } from "../../applications/utils/StringUtils";
import { ApiClient } from "../api/ApiClient";
import {
  CreateInventoryAuditRequest,
  FilterInventoryAuditRequest,
  InventoryAuditDetailModel,
  InventoryAuditModel,
} from "../model/InventoryAuditModel";

const BASE_ULR = "/api/inventory-audit";

class InventoryAuditServiceClass {
  getInventoryAudit(request: FilterInventoryAuditRequest) {
    const params = buildRequestToParams(request);
    return ApiClient.get<PageResponse<InventoryAuditModel[]>>(BASE_ULR + `?${params}`);
  }

  getSummaryInventoryAudit() {
    return ApiClient.get<InventoryAuditModel[]>(BASE_ULR + `/summary`);
  }

  getInventoryAuditDetails(auditId: number) {
    return ApiClient.get<InventoryAuditDetailModel[]>(BASE_ULR + `/${auditId}/detail`);
  }

  createImportInventoryAudit(request: CreateInventoryAuditRequest) {
    return ApiClient.post<InventoryAuditModel>(BASE_ULR, request);
  }

  deleteInventoryAudit(id: number) {
    return ApiClient.delete(BASE_ULR + `/${id}`);
  }
}

const InventoryAuditService = new InventoryAuditServiceClass();
export default InventoryAuditService;
